<template>
  <card title="Tu información">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="update"
      @keydown="form.onKeydown($event)"
    >
      <v-container grid-list-xl>
        <v-layout
          id="ref"
          class="wrap justify-space-around form-body"
        >
          <v-col cols="6">
            <v-text-field
              v-model="form.name"
              :rules="[rules.required]"
              label="Nombre"
              required
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.email"
              :rules="[rules.required, rules.emailFormat]"
              label="Correo Electronico"
              :readonly="true"
              required
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.identificator"
              :rules="[rules.required, rules.identificatorFormat, rules.identificatorLength]"
              label="Identificación"
              placeholder="Cédula"
              :maxlength="20"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.phone"
              placeholder="####-#### / ######-####-####"
              maxlength="16"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="form.cat_province_id"
              :items="itemsProvince"
              item-value="id"
              item-text="name"
              label="Provincia"
              @change="getDistrito()"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="form.cat_district_id"
              :items="itemsDistrict"
              item-value="id"
              item-text="name"
              label="Distrito"
              @change="getCorregimiento()"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="form.cat_corregimiento_id"
              :items="itemsCorregimiento"
              item-value="id"
              item-text="name"
              label="Corregimiento"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.address"
              :maxlength="300"
              label="Dirección"
              placeholder="Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá"
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              v-if="can('actualiza_perfil_usuario')"
              :loading="form.busy"
              :disabled="!valid || form.busy"
              class="mr-4"
              block
              color="success"
              @click="validate"
            >
              ACTUALIZAR
            </v-btn>
          </v-col>
        </v-layout>
      </v-container>
    </v-form>
  </card>
</template>

<script>
import Form from 'vform';
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';

export default {
  directives: {
    mask,
  },
  metaInfo() {
    return this.title;
  },
  data: () => ({
    form: new Form({
      name: '',
      email: '',
      identificator: '',
      phone: '',
      cat_corregimiento_id: '',
      cat_district_id: '',
      cat_province_id: '',
      address: '',
      busy: false,
      title: 'Configuraciones',
    }),
    valid: false,
    itemsProvince: [],
    itemsDistrict: [],
    itemsCorregimiento: [],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
      identificatorLength: (v) => (v.length >= 5 && v.length <= 20) || 'El campo debe tener de 5 a 20 caracteres.',
      identificatorFormat: (v) => /^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
      || 'El campo debe tener un formato válido.',
    },
    apiURL: '/api/settings/profile',
  }),

  computed: mapGetters({
    user: 'auth/user',
  }),

  created() {
    // Fill the form with user data.
    this.form.keys().forEach((key) => {
      this.form[key] = this.user[key];
    });
  },
   watch: {
    'form.cat_province_id': {
      handler() {
        this.getDistrito();
      },
    },
    'form.cat_district_id': {
      handler() {
        this.getCorregimiento();
      },
    },
  },
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
    });
    const URL = `${this.apiURL}`;
    this.URL = URL;
      window.axios.get('/api/user')
      .then((result) => {
        Object.assign(this.form, result.data);
        this.URL = '/api/settings/profile';
        this.method = 'PUT';
        this.title = 'Actualizar información';
        this.message = 'Se ha actualizado la información exitosamente.';
      });
  },

  methods: {
    update() {
      window.axios({
        method: this.method,
        url: this.URL,
        data: this.form,
      }).then((result) => {
        this.$router.push({ name: 'settings.profile', params: { action: 'created', message: result.data.message } });
        this.form.busy = false;
      }).catch(() => {
        this.form.busy = false;
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.update();
      }
    },
    getProvincia() {
      const url = '/api/provinces';
      return window.axios.get(url);
    },
    getDistrito() {
      if (this.form.cat_province_id) {
          const url = `/api/districts/${this.form.cat_province_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsDistrict = response.data;
        });
      }
    },
    getCorregimiento() {
      if (this.form.cat_district_id) {
          const url = `/api/corregimientos/${this.form.cat_district_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsCorregimiento = response.data;
        });
      }
    },
  },
};
</script>
